﻿let _ = require('lodash');
let Q = require('q');
let URI = require('urijs');

const LuminateConsApiEndpoint = "CRConsAPI";

module.exports = LuminateSession;

function LuminateSession() {
    let baseUri = luminateClientApiConfig.BaseUrl;
    this.apiUrl = URI(baseUri).segment(LuminateConsApiEndpoint);

    this.luminateConfig = {
        api_key: luminateClientApiConfig.ApiKey,
        v: luminateClientApiConfig.Version
    };
}

LuminateSession.prototype = {
    assertOpen() {
        return this.getSSOToken()
            .then(token => this.openLuminateSession(token))
            .then(() => true)
            .catch(error => {
                if (error.status === 404) { return false; }
                else { throw error; }
            });
    },

    getSSOToken() {
        return Q($.ajax({
            url: jnfroutesconfg.SSOTokenUrl,
            type: 'POST'
        }))
        .then(response => response.Token);
    },

    isSessionOpen() {
        return Q($.ajax({
            url: this.apiUrl,
            type: 'POST',
            data: _.assign({
                method: 'loginTest',
            }, this.luminateConfig),
            xhrFields: { withCredentials: true },
        }))
        .then(() => true)
        .catch(error => {
            if (error.status === 403) {
                return false;
            } else {
                console.log(error);
            }
        });
    },

    openLuminateSession(ssoToken) {
        return Q($.ajax({
            url: this.apiUrl,
            type: 'POST',
            data: _.assign({
                method: 'singleSignOn',
                sso_auth_token: ssoToken,
            }, this.luminateConfig),
            xhrFields: { withCredentials: true },
        }));
    },

    closeLuminateSession() {
        return Q($.ajax({
            url: this.apiUrl,
            type: 'POST',
            data: _.assign({
                method: 'logout',
            }, this.luminateConfig),
            xhrFields: { withCredentials: true },
        }));
    }
}
